import { generateVariantData } from '../../../../experiments/utils';

const imgURL = `${process.env.REACT_APP_CLOUDFRONT_URL}/flagship/home-page`;

const variantToDataMapping = {
  homepageRedesign: {
    header: 'Coding is a universal language. Become fluent in 3 easy steps!',
    steps: [
      {
        img: `${imgURL}/learn_abcs_coding_compressed.png`,
        title: 'Learn the ABCs of coding',
        body:
          'Our online classes and word-free app introduce kids to the fundamentals of coding. They learn basic commands, simple game design, and how to communicate and express themselves through code.',
      },
      {
        img: `${imgURL}/practice_through_play_compressed.png`,
        title: 'Practice through play',
        body:
          'Kids get to practice their new language in a fun, game-based environment. They create code phrases through puzzles and games, apply real game design principles, and have a blast learning!',
      },
      {
        img: `${imgURL}/express_yourself_code_compressed.png`,
        title: 'Express yourself with code!',
        body:
          'Games are the stories we tell through the powerful language of code. Once kids know how to write code, they tap into their endless imaginations to create, build, and share their own games with other kid coders.',
      },
    ],
  },
};

const DEFAULT_DATA = 'homepageRedesign';
export const getCodingStepsVariantData = generateVariantData(variantToDataMapping, DEFAULT_DATA);



// WEBPACK FOOTER //
// ./src/containers/Home/sections/CodingSteps/codeStepsData.js